import { render, staticRenderFns } from "./text-glitch.vue?vue&type=template&id=7170564f&scoped=true&"
import script from "./text-glitch.vue?vue&type=script&lang=js&"
export * from "./text-glitch.vue?vue&type=script&lang=js&"
import style0 from "./text-glitch.vue?vue&type=style&index=0&id=7170564f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170564f",
  null
  
)

export default component.exports